import { ObjectUtil } from './ObjectUtil'
import { AppJumpXiaoyuUtil } from './AppJumpXYUtil'

export interface AppJumpConfig {
  harmony?: { page: string; params?: any }
  android: { page: string; params?: any }
  ios: { page: string; params?: any }
}

export class AppJumpUtil {
  // 所有的配置都放这
  public static readonly config = {
    xiaoYu: AppJumpXiaoyuUtil.config,

    homepage: {
      android: {
        page: 'com.gkid.crazyrope.ui.home.HomeActivity',
        params: {},
      },
      ios: {
        page: 'MainViewController',
        params: {},
      },
      harmony: {
        page: 'MainPage',
        params: {},
      },
    },
    projects: {
      android: {
        page: 'com.gkid.crazyrope.ui.home.HomeActivity',
        params: { 'home.tab.index': '1' },
      },
      ios: {
        page: 'MyPlanBaseViewController',
        params: {},
      },
      harmony: {
        page: 'MainPage',
        params: { page: 'MainPage_TaskTab' },
      },
    },
    friends: {
      android: {
        page: 'com.gkid.crazyrope.ui.home.HomeActivity',
        params: { selectedType: 'friend' },
      },
      ios: {
        page: 'FriendTabViewController',
        params: { selectedType: 'friend' },
      },
      harmony: {
        page: 'MainPage',
        params: { page: 'MainPage_FriendTab' },
      },
    },
    livingRoom: {
      android: {
        page: 'com.gkid.crazyrope.ui.home.HomeActivity',
        params: {
          action: 'com.gkid.crazyrope.HOME.TAB',
          'home.tab.index': '1',
        },
      },
      ios: {
        page: 'LivingRoomViewController',
        params: {},
      },
    },
    liveMyAppointments: {
      // 直播课- 我的预约
      android: {
        page: 'com.gkid.crazyrope.ui.live.MyAppointmentsActivity',
        params: {},
      },
      ios: {
        page: 'LiveAppointmentViewController',
        params: {},
      },
    },
    // category: labs,body_fitness,ai_jump_rope,fun_sports,ai_running,gymnastics,dance,balls,ai_course,basketball,fitcat
    fun_sports: {
      harmony: {
        page: 'FunSportPage',
        params: {},
      },
      android: {
        page: 'com.gkid.crazyrope.ui.home.tab1.KingKongContainerActivity',
        params: { TITLE: '趣运动', CATEGORY: 'FunSports' },
      },
      ios: {
        page: 'CRFunSportsDetailViewController',
        params: {},
      },
      name: '趣运动',
    },
    ai_running: {
      // 原地跑
      android: {
        page: 'com.gkid.crazyrope.ui.home.HomeActivity',
        params: { 'home.tab.index': '1', 'home.tab.inner.category': 'ai_running' },
      },
      ios: {
        page: 'MyPlanBaseViewController',
        params: { selectedType: 'ai_running' },
      },
      harmony: {
        page: 'RunPage',
        params: {},
      },
    },
    gymnastics: {
      // 广播操
      android: {
        page: 'com.gkid.crazyrope.ui.home.tab1.KingKongContainerActivity',
        params: { TITLE: '广播操', CATEGORY: 'Move' },
      },
      ios: {
        page: 'CRMoveDetailViewController',
        params: {},
      },
      harmony: {
        page: 'GymnasticPage',
        params: {},
      },
    },
    dance: {
      // 合舞团
      android: {
        page: 'com.gkid.crazyrope.ui.home.HomeActivity',
        params: { 'home.tab.index': '1', 'home.tab.inner.category': 'dance' },
      },
      ios: {
        page: 'MyPlanBaseViewController',
        params: { selectedType: 'dance' },
      },
      harmony: {
        page: 'DanceGroupPage',
        params: {},
      },
    },
    arena: {
      android: {
        page: 'com.gkid.crazyrope.ui.arena.ArenaActivity',
        params: {},
      },
      ios: {
        page: 'ArenaBaseViewController',
        params: {},
      },
    },
    hallfame: {
      android: {
        page: 'com.gkid.crazyrope.ui.detail.DrillFamersActivity',
        params: {},
      },
      ios: {
        page: 'JumpRopeMasterViewController',
        params: {},
      },
    },
    openURL: {
      harmony: {
        page: 'WebPage',
        params: {},
      },
      android: {
        page: 'com.gkid.crazyrope.ui.base.WebActivity',
        params: {},
      },
      ios: {
        page: 'LLWebViewController',
        params: {},
      },
    },
    rankAuth: {
      android: {
        page: 'com.gkid.crazyrope.ui.settings.SetRankOpActivity',
        params: {},
      },
      ios: {
        page: 'RankAuthorityViewController',
        params: {},
      },
      harmony: {
        page: 'ReportVideoPermissionPage',
        params: {},
      },
    },
    setting: {
      harmony: {
        page: 'UserInfoEditPage',
        params: {},
      },
      android: {
        page: 'com.gkid.crazyrope.ui.user.UserProfileEditActivity',
        params: {},
      },
      ios: {
        page: 'UserInfoSettingViewController',
        params: { needPopBack: true },
      },
    },
    wechatNotificationSetting: {
      android: {
        page: 'com.gkid.crazyrope.ui.settings.WeChatNotificationSettingActivity',
        params: {},
      },
      ios: {
        page: 'LLWechatSettingVController',
        params: {},
      },
    },
    qrCodeScanner: {
      android: {
        page: 'com.gkid.crazyrope.ui.settings.ScanActivity',
        params: {},
      },
      ios: {
        page: 'LLQRCodeScanViewController',
        params: {},
      },
      harmony: {
        page: 'ScanPage',
        params: {},
      },
    },
    examTest2021: {
      android: {
        page: 'com.gkid.crazyrope.ui.cloudtest.WholePeopleCloudBodyTestActivity',
        params: {},
      },
      ios: {
        page: 'BodyExamEventViewController',
        params: {},
      },
    },
    AddFriend: {
      harmony: {
        page: 'AddFriendsPage',
        params: {},
      },
      android: {
        page: 'com.gkid.crazyrope.ui.friends.AddFriendsActivity',
        params: {},
      },
      ios: {
        page: 'AddFriendViewController',
        params: {},
      },
    },
    AppHelpActivity: {
      android: {
        page: 'com.gkid.crazyrope.ui.settings.AppHelpActivity',
        params: {},
      },
      ios: {
        page: 'HelpViewController',
        params: {},
      },
    },
    RopeLevel: {
      android: {
        page: 'com.gkid.crazyrope.ui.ropedans.DanListActivity',
        params: {},
      },
      ios: {
        page: 'RopeLevelViewController',
        params: {},
      },
    },
    plans: {
      // 运动计划页
      android: {
        page: 'com.gkid.crazyrope.ui.plans.PlanConfActivity',
        params: {},
      },
      ios: {
        page: 'PlanListViewController',
        params: {},
      },
    },
    planDetails: {
      android: {
        page: 'com.gkid.crazyrope.ui.thematic.ThematicPlanDetailActivity',
        params: {},
      },
      ios: {
        page: 'AITrainingPlanDetailViewController',
        params: {},
      },
    },
    thematicPlans: {
      // 专题计划
      android: {
        page: 'com.gkid.crazyrope.ui.thematic.ThematicPlanActivity',
        params: {},
      },
      ios: {
        page: 'AITrainingPlanListViewController',
        params: {},
      },
    },
    homeworkHome: {
      android: {
        page: 'com.gkid.crazyrope.ui.homework.HomeworkActivity',
        params: {},
      },
      ios: {
        page: 'PlanViewController', // page: 'HomeworkMainViewController',
        params: { pageToShow: 1 }, // params: {},
      },
      harmony: {
        page: 'SportsHomeworkPage',
        params: {},
      },
    },
    taskPageTabTask: {
      android: {
        page: 'com.gkid.crazyrope.ui.home.HomeActivity',
        params: {
          action: 'com.gkid.crazyrope.HOME.TAB',
          'home.tab.index': '2',
          'home.tab.inner.index': '0',
        },
      },
      ios: {
        page: 'PlanViewController',
        params: {
          pageToShow: 0,
        },
      },
    },
    plansNew: {
      android: {
        page: 'home_tab_plan',
        params: {},
      },
      ios: {
        page: 'PlanViewController',
        params: {
          pageToShow: 0,
        },
      },
      harmony: {
        page: 'MainPage',
        params: {
          action: 'MainPageTab',
          page: 'PlanTab',
        },
      },
      name: '计划',
    },
    sportsCourse: {
      android: {
        page: 'com.gkid.crazyrope.ui.home.HomeActivity',
        params: {
          action: 'com.gkid.crazyrope.HOME.TAB',
          'home.tab.index': '2',
          'home.tab.inner.index': '3',
        },
      },
      ios: {
        page: 'PlanViewController',
        params: {
          pageToShow: 3,
        },
      },
    },
    sportsCourseDetails: {
      android: {
        page: 'com.gkid.crazyrope.ui.plan.AICourseDetailActivity',
        params: {},
      },
      ios: {
        page: 'PlanCourseDetailVController',
        params: {},
      },
    },
    homeworkDetails: {
      android: {
        page: 'com.gkid.crazyrope.SportHomeWorkDetailActivity',
        params: {},
      },
      ios: {
        page: 'HomeworkViewController',
        params: {},
      },
    },
    homeworkRank: {
      android: { page: 'com.gkid.crazyrope.ui.homework.HwPunchActivity' },
      ios: { page: 'HomeworkRankViewController' },
      harmony: { page: 'PunchCardsPage' },
    },
    FriendSelector: {
      harmony: { page: 'SelectSendToFriendPage' },
      android: { page: 'com.gkid.crazyrope.ui.friends.SelectSendToFriendActivity' },
      ios: { page: 'FriendChooseViewController' },
    },
    order: {
      android: { page: 'com.gkid.crazyrope.ui.order.CompleteRegistrationInfoActivity' },
      ios: { page: 'SignUpViewController' },
    },
    orderList: {
      android: { page: 'com.gkid.crazyrope.ui.order.OrderListActivity' },
      ios: { page: 'MyOrderListViewController' },
    },
    orderDetail: {
      android: { page: 'com.gkid.crazyrope.ui.order.OrderDetailActivity', params: { id: '' } },
      ios: { page: 'MyOrderDetailViewController', params: { order_id: '' } },
    },
    login: {
      android: { page: 'com.gkid.crazyrope.ui.login.LogInActivity' },
      ios: { page: 'LoginPhoneNumInputViewController', params: { bIsBindPhone: true } },
      harmony: { page: 'PhoneNumberLoginPage' },
    },
    rope: {
      harmony: {
        page: 'JumpRopePage',
        params: {},
      },
      android: {
        page: 'com.gkid.crazyrope.ui.home.tab1.KingKongContainerActivity',
        params: { TITLE: '跳绳', CATEGORY: 'AiJumpRope' },
      },
      ios: { page: 'CRRopeDetailViewController' },
      name: '跳绳',
    },
    running: {
      android: {
        page: 'com.gkid.crazyrope.ui.home.tab1.KingKongContainerActivity',
        params: { TITLE: '跑步', CATEGORY: 'Run' },
      },
      ios: { page: 'CRRunningDetailViewController' },
      harmony: { page: 'RunPage' },
    },
    ball: {
      android: {
        page: 'com.gkid.crazyrope.ui.home.tab1.KingKongContainerActivity',
        params: { TITLE: '球类', CATEGORY: 'Balls' },
      },
      ios: { page: 'CRBallDetailViewController' },
    },
    bodyFitness: {
      android: {
        page: 'com.gkid.crazyrope.ui.home.tab1.KingKongContainerActivity',
        params: { TITLE: '体能', CATEGORY: 'PhysicalFitness' },
      },
      ios: { page: 'CRBodyFitnessViewController' },
      harmony: { page: 'PhysicalPage' },
    },
    drillDetails: {
      android: {
        page: 'com.gkid.crazyrope.ui.detail.DrillDetailActivity',
        params: {}, // drill
      },
      ios: {
        page: 'DrillDetailViewController',
        params: {}, // drill_id
      },
      harmony: {
        page: 'DrillDetailPage',
        params: {}, // drillId
      },
      name: 'drill详情页',
    },
    meta: {
      android: {
        page: 'com.gkid.crazyrope.ui.home.tab1.MetaVerseActivity',
        params: {},
      },
      ios: {
        page: 'MetaverseListViewController',
        params: {},
      },
      name: '元宇宙入口',
    },
    heartRate: {
      android: {
        page: 'com.gkid.crazyrope.ui.home.tab1.KingKongContainerActivity',
        params: { TITLE: '测心率', CATEGORY: 'HeartRate' },
      },
      ios: {
        page: 'HeartBeatsViewController',
        params: {},
      },
    },
    drillRecords: {
      harmony: {
        page: 'DrillRecordPage',
        params: {},
      },
      android: {
        page: 'com.gkid.crazyrope.ui.record.TrainingRecordsActivity',
        params: {},
      },
      ios: {
        page: 'VideoCollectionBaseViewController',
        params: {},
      },
    },
    myHonor: {
      harmony: {
        page: 'MyHonorPage',
        params: {},
      },
      android: {
        page: 'com.gkid.crazyrope.ui.honor.MyHonorActivity',
        params: {},
      },
      ios: {
        page: 'AchievementViewController',
        params: {},
      },
    },
    sportTarget: {
      android: {
        page: 'com.gkid.crazyrope.ui.calendar.target.SportTargetActivity',
        params: {},
      },
      ios: {
        page: 'SportTargetViewController',
        params: {},
      },
    },
    energyShop: {
      android: {
        page: 'com.gkid.crazyrope.ui.cloth.ClothAwardActivity',
        params: { key: 'jumprope' },
      },
      ios: {
        page: 'EnergyShopViewController',
        params: {},
      },
      harmony: {
        page: 'ClothAwardPage',
        params: {},
      },
      name: '能量豆商店',
    },
    // 会员页
    splus: {
      android: {
        page: 'com.gkid.crazyrope.ui.home.HomeActivity',
        params: {
          action: 'com.gkid.crazyrope.HOME.TAB',
          'home.tab.index': '0',
          'home.tab.inner.index': '1',
        },
      },
      ios: {
        page: 'MainViewController',
        params: {
          pageTab: 'splus',
        },
      },
      name: 'S+会员',
    },
    // 会员购买页
    plusMember: {
      android: {
        page: 'com.gkid.crazyrope.ui.member.MemberActivity',
        params: {},
      },
      ios: {
        page: 'LLSPlusMemberViewController',
        params: {},
      },
      name: '运动会员',
    },
    superGame: {
      android: {
        page: 'com.gkid.crazyrope.ui.arena.ArenaActivity',
        params: {},
      },
      ios: {
        page: 'SuperGameMainViewController',
        params: {},
      },
    },
    pay: {
      android: {
        page: 'com.gkid.crazyrope.ui.order.PayActivityV2',
        params: {},
      },
      ios: {
        page: 'MyOrderSubmitViewController',
        params: {},
      },
    },
    fitcat: {
      android: {
        page: 'com.gkid.crazyrope.ui.funsports.FitCatActivity',
        params: {},
      },
      ios: {
        page: 'FitCatViewController',
        params: {},
      },
    },
    gift2Friends: {
      android: {
        page: 'com.gkid.crazyrope.ui.scard.MemberScardActivity',
        params: {},
      },
      ios: {
        page: 'SPlusCourtesyPresentedViewController',
        params: {},
      },
      harmony: {
        page: 'MemberCardPage',
        params: {},
      },
    },
    unityJump: {
      android: {
        page: 'UnityActivityController',
        params: {},
      },
      ios: {
        page: 'UnityActivityController',
        params: {}, // navigate: changedress 换装, workshop 工坊
      },
      harmony: {
        page: 'drill_play',
        params: { ext_infos: {}, drill_id: '' },
      },
      name: 'unity页面跳转',
    },
    drillRank: {
      android: {
        page: 'com.gkid.crazyrope.ui.ranks.RankListActivityV2',
        params: {},
      },
      ios: {
        page: 'RankListViewController',
        params: {},
      },
    },
    dailyReward: {
      android: {
        page: 'com.gkid.crazyrope.ui.home.me.DailyGiftActivity',
        params: {},
      },
      ios: {
        page: 'DailyRewardViewController',
        params: {},
      },
      name: '每日福利',
    },
    sportsShowMall: {
      harmony: {
        page: 'MainPage',
        params: {
          page: 'HomeShoppingMallTab',
          action: 'MainPageTab',
        },
      },
      android: {
        page: 'com.gkid.crazyrope.ui.cloth.ClothActActivity',
        params: {},
      },
      ios: {
        page: 'SportShowStoreMainViewController',
        params: {},
      },
      name: '运动秀商城',
    },
    personalSportsSpace: {
      android: {
        page: 'com.gkid.crazyrope.ui.clazz.ClsMemberInfoActivity',
        params: {},
      },
      ios: {
        page: 'UserSportSpaceViewController',
        params: {},
      },
    },
    drillCourse: {
      android: {
        page: 'com.gkid.crazyrope.ui.novice.NoviceCourseListActivity',
        params: {},
      },
      ios: {
        page: 'FmAllCourseVController',
        params: {},
      },
    },
    // 运动卡
    sportsCards: {
      android: {
        page: 'com.gkid.crazyrope.ui.cardcollecting.SportCardHomeActivity',
        params: {},
      },
      ios: {
        page: 'GachaGameViewController',
        params: {},
      },
      name: '运动卡包',
    },
    // 运动卡牌商店
    sportsCardStore: {
      harmony: {
        page: 'SportCardMainPage',
        params: {},
      },
      android: {
        page: 'com.gkid.crazyrope.ui.cardcollecting.CardShopActivity',
        params: {},
      },
      ios: {
        page: 'SportCardsStoreVController',
        params: {},
      },
    },
    // 体智云原生跳转配置
    tzyHome: {
      android: {
        page: 'com.tizhiyun.app.ui.home.HomeActivity',
        params: {},
      },
      ios: {
        page: 'HomeworkMainController',
        params: {},
      },
    },
    jkcHome: {
      android: {
        page: 'com.gkid.crazyrope.ui.jkc.FollowVideoListActivity',
        params: {},
      },
      ios: {
        page: 'VideoPracticeMainViewController',
        params: {},
      },
    },
    // 头像框
    avatarDecoration: {
      android: {
        page: 'com.gkid.crazyrope.ui.user.AvatarDecorateActivity',
        params: {},
      },
      ios: {
        page: 'AvatarDecorationViewController',
        params: {},
      },
    },
    // 吃豆人专项页（AR吃豆人）
    pacman: {
      android: {
        page: 'com.gkid.crazyrope.ui.funsports.pacman.ARPacmanActivity',
        params: {},
      },
      ios: {
        page: 'PacmanViewController',
        params: {},
      },
    },
    // 群聊
    groupChat: {
      harmony: {
        page: 'GroupTalkPage',
        params: {},
      },
      android: {
        page: 'com.gkid.crazyrope.ui.group.GroupTalkActivity',
        params: {},
      },
      ios: {
        page: 'MyActicityGroupMsgVController',
        params: {},
      },
    },
    // drill搜索页
    searchDrill: {
      // 鸿蒙暂时先跳转到趣运动页
      harmony: {
        page: 'FunSportPage',
        params: {},
      },
      android: {
        page: 'com.gkid.crazyrope.ui.search2.Search2Activity',
        params: {},
      },
      ios: {
        page: 'HomeSearchViewController',
        params: {},
      },
    },
    // 活动页
    activityHome: {
      android: {
        page: 'com.gkid.crazyrope.ui.home.HomeActivity',
        params: {
          action: 'com.gkid.crazyrope.HOME.TAB',
          'home.tab.index': '0',
          'home.tab.inner.index': '2',
        },
      },
      ios: {
        page: 'MainViewController',
        params: {
          pageTab: 'activity',
        },
      },
    },
    aiPet: {
      android: {
        page: 'home_tab_ai_pet',
        params: {},
      },
      ios: {
        page: 'PetMainViewController',
        params: {},
      },
      name: '好友-Tabu',
    },
    tabSplus: {
      android: {
        page: 'home_tab_svip',
        params: {},
      },
      ios: {
        page: 'MainViewController',
        params: {
          pageTab: 'splus',
        },
      },
      name: '首页-会员',
    },
    tabActivity: {
      android: {
        page: 'home_tab_activity',
        params: {},
      },
      ios: {
        page: 'MainViewController',
        params: {
          pageTab: 'activity',
        },
      },
      name: '首页-活动',
    },
    tabHomework: {
      harmony: {
        page: 'MainPage',
        params: {
          action: 'MainPageTab',
          page: 'HomeworkTab',
        },
      },
      android: {
        page: 'home_tab_homework',
        params: {},
      },
      ios: {
        page: 'HomeworkMainViewController',
      },
      name: '校园-作业', // 校园-作业
    },
    tabHomeworkHomework: {
      android: {
        page: 'home_tab_homework',
        params: {},
      },
      ios: {
        page: 'HomeworkMainViewController',
        params: { tabToShow: 'homework', homeworkTabName: '作业' },
      },
      name: '校园-作业-作业', // 校园-作业-作业
    },
    tabHomeworkMatch: {
      android: {
        page: 'home_tab_campus_match',
        params: {},
      },
      ios: {
        page: 'HomeworkMainViewController',
        params: { tabToShow: 'homework', homeworkTabName: '比赛' },
      },
      name: '校园-作业-比赛',
    },
    tabHomeworkTask: {
      android: {
        page: 'home_tab_campus_task',
        params: {},
      },
      ios: {
        page: 'HomeworkMainViewController',
        params: { tabToShow: 'homework', homeworkTabName: '任务' },
      },
      name: '校园-作业-任务',
    },
    tabCompetition: {
      android: {
        page: 'home_tab_competition',
        params: {},
      },
      ios: {
        page: 'SchoolCompetitionViewController',
      },
      name: '校园-比赛',
    },
    tabFriends: {
      android: {
        page: 'home_tab_friends',
        params: {},
      },
      ios: {
        // noop
      },
      name: '好友-好友',
    },
    tabTeams: {
      android: {
        page: 'home_tab_team',
        params: {},
      },
      ios: {
        // noop
      },
      name: '好友-小队',
    },
    tabMine: {
      android: {
        page: 'home_tab_mine',
        params: {},
      },
      ios: {
        // noop
      },
      name: '我的',
    },
    motionAnalyze: {
      android: {
        page: 'com.gkid.crazyrope.ui.base.MotionAnalysisActivity',
        params: {},
      },
      ios: {
        page: 'PacmanViewControllerCopy',
        params: {},
      },
    },
    sportsCourseLanding: {
      android: {
        page: 'com.gkid.crazyrope.ui.plan.evaluation.EvaluationMemberActivity',
        params: {},
      },
      ios: {
        page: 'UserPlanSplusViewController',
        params: {},
      },
      unityPartyLobbyParty: {
        android: {
          page: 'UnityActivityController',
          params: { drill_id: 'game_party_lobby_party_mode_2305' },
        },
        ios: {
          page: 'UnityActivityController',
          params: { drill_id: 'game_party_lobby_party_mode_2305' },
        },
        harmony: {
          page: 'drill_play',
          params: { drill_id: 'game_party_lobby_party_mode_2305' },
        },
        name: 'unity 派对模式大厅',
      },
      unityPartyLobby: {
        android: {
          page: 'UnityActivityController',
          params: { drill_id: 'game_party_lobby_2307' },
        },
        ios: {
          page: 'UnityActivityController',
          params: { drill_id: 'game_party_lobby_2307' },
        },
        harmony: {
          page: 'drill_play',
          params: { drill_id: 'game_party_lobby_2307' },
        },
        name: 'unity 练习模式大厅',
      },
      unityPartyLobbyCompetition: {
        android: {
          page: 'UnityActivityController',
          params: { drill_id: 'game_party_lobby_competition_mode_2309' },
        },
        ios: {
          page: 'UnityActivityController',
          params: { drill_id: 'game_party_lobby_competition_mode_2309' },
        },
        harmony: {
          page: 'drill_play',
          params: { drill_id: 'game_party_lobby_competition_mode_2309' },
        },
        name: 'unity 巅峰赛',
      },
      unityLobbyArena: {
        android: {
          page: 'UnityActivityController',
          params: { drill_id: 'game_pk_lobby_arena_2306' },
        },
        ios: {
          page: 'UnityActivityController',
          params: { drill_id: 'game_pk_lobby_arena_2306' },
        },
        harmony: {
          page: 'drill_play',
          params: { drill_id: 'game_pk_lobby_arena_2306' },
        },
        name: 'unity 趣竞技',
      },
      blastHeroUnity: {
        android: {
          page: 'UnityActivityController',
          params: { drill_id: 'game_blast_battery_2310' },
        },
        ios: {
          page: 'UnityActivityController',
          params: { drill_id: 'game_blast_battery_2310' },
        },
        harmony: {
          page: 'drill_play',
          params: { drill_id: 'game_blast_battery_2310' },
        },
        name: 'unity爆破英雄',
      },
      sportsIslandUnity: {
        android: {
          page: 'UnityActivityController',
          params: { drill_id: 'sports_island_2403' },
        },
        ios: {
          page: 'UnityActivityController',
          params: { drill_id: 'sports_island_2403' },
        },
        harmony: {
          page: 'drill_play',
          params: { drill_id: 'sports_island_2403' },
        },
        name: '我的运动岛',
      },
      funsportsUnity: {
        android: {
          page: 'UnityActivityController',
          params: { drill_id: 'funsports_test_2209' },
        },
        ios: {
          page: 'UnityActivityController',
          params: { drill_id: 'funsports_test_2209' },
        },
        harmony: {
          page: 'drill_play',
          params: { drill_id: 'funsports_test_2209' },
        },
        name: 'Unity运动秀首页',
      },
      faceMakingUnity: {
        android: {
          page: 'UnityActivityController',
          params: { ext_infos: { navigate: 'buildFace' }, drill_id: 'funsports_test_2209' },
        },
        ios: {
          page: 'UnityActivityController',
          params: { ext_infos: { navigate: 'buildFace' }, drill_id: 'funsports_test_2209' },
        },

        harmony: {
          page: 'drill_play',
          params: { ext_infos: { navigate: 'buildFace' }, drill_id: 'funsports_test_2209' },
        },
        name: 'Unity捏脸',
      },
      dailyGift: {
        android: {
          page: 'com.gkid.crazyrope.ui.home.me.DailyGiftActivity',
          params: {},
        },
        ios: {
          page: 'DailyRewardViewController',
          params: {},
        },
        harmony: {
          page: 'DailyGiftPage',
          params: {},
        },
        name: '每日福利领取',
      },
      cardShop: {
        android: {
          page: 'com.gkid.crazyrope.ui.cardcollecting.CardShopActivity',
          params: {},
        },
        ios: {
          page: 'SportCardsStoreVController',
          params: {},
        },
        name: '卡牌商店',
      },
      virtualRoomEntry: {
        android: {
          page: 'com.gkid.crazyrope.ui.virtual.entry.VirtualRoomEntryActivity',
          params: {},
        },
        ios: {
          page: 'VirtualEntranceViewController',
          params: {},
        },
        name: '在线运动房列表',
      },
      authManager: {
        android: {
          page: 'com.gkid.crazyrope.ui.settings.PermissionListActivity',
          params: {},
        },
        ios: {
          page: 'CRAuthManagerViewController',
          params: {},
        },
        name: '系统权限设置',
      },
      recommendSetting: {
        android: {
          page: 'com.gkid.crazyrope.ui.settings.PersonalActivity',
          params: {},
        },
        ios: {
          page: 'RecommendSettingViewController',
          params: {},
        },
        harmony: {
          page: 'PersonalPage',
          params: {},
        },
        name: '个性化推荐设置 ',
      },
      planEvaluation: {
        android: {
          page: 'com.gkid.crazyrope.ui.plan.evaluation.EvaluationProfileActivity',
          params: {
            fromId: '',
          },
        },
        ios: {
          page: 'UserInfoGuideViewController',
          params: {
            fromId: '',
            planMode: true,
          },
        },
        name: '计划定制页面 ',
      },
    },
  }

  public static getHomepageConfig() {
    return this._buildDict(this.config.homepage)
  }

  public static buildDictByName(name: AppNativePageName) {
    return this._buildDict(ObjectUtil.get(this.config, name))
  }

  // 打开url需要的
  public static buildOpenURLDict(url: string, title?: string): any {
    const cfg = this.config.openURL
    cfg.android.params = { url, title }
    cfg.ios.params = { url, strTitle: title }

    if (cfg.harmony?.params) {
      cfg.harmony.params = { url, title }
    }

    return this._buildDict(cfg)
  }

  public static _buildDict(cfg: AppJumpConfig) {
    return {
      action: 'jump',
      iOS_page: cfg.ios.page,
      iOS_param: cfg.ios.params || {},
      Android_page: cfg.android.page,
      Android_param: cfg.android.params || {},
      HarmonyOS_page: cfg.harmony?.page || {},
      HarmonyOS_param: cfg.harmony?.params || {},
    }
  }
}

export const redirectMap: Record<string, { target: AppNativePageName; version: string }> = {
  taskPageTabTask: {
    target: 'plansNew',
    version: '4.0.72',
  },
  activityHome: {
    target: 'tabActivity',
    version: '4.0.74',
  },
  splus: {
    target: 'tabSplus',
    version: '4.0.74',
  },
  friends: {
    target: 'tabFriends',
    version: '4.0.74',
  },
}

export type AppNativePageName =
  | Exclude<keyof typeof AppJumpUtil['config'], 'xiaoYu'>
  | `xiaoYu.${keyof typeof AppJumpXiaoyuUtil['config']}`
